import _ from 'lodash';

export default function (instance) {
  const originalCreateTask = instance.createTask;
  const originalAddTask = instance.addTask;
  const originalAddLink = instance.addLink;

  instance.createTask = function () {
    const task = arguments[0];

    if (task && task.type === instance.config.types.milestone) {
      task.duration = 0;
    }

    if (task && _.isUndefined(task.id) && task.type !== instance.config.types.button) {
      task.id = instance.ganttDataApi.generateUID();
    }

    const taskId = originalCreateTask.apply(this, arguments);

    instance.unselectTask(taskId);

    return taskId;
  };

  instance.addTask = function () {
    const task = arguments[0];

    if (task && _.isUndefined(task.id) && task.type !== instance.config.types.button) {
      task.id = instance.ganttDataApi.generateUID();
    }

    return originalAddTask.apply(this, arguments);
  };

  instance.addLink = function () {
    const link = arguments[0];

    if (link && _.isUndefined(link.id)) {
      link.id = instance.ganttDataApi.generateUID();
    }

    // need for case when project task disapear after add link to it, when total estimate change start date to future dates
    if (instance.getTask(link.target).type === instance.config.types.project) {
      setTimeout(() => {
        instance.updateTask(link.target);
      }, 0);
    }

    return originalAddLink.apply(this, arguments);
  };
}
